// import colors from 'vuetify/lib/util/colors'
export default {
  primary: '#326baf',
  secondary: '#faad39',
  icons: '#326baf',
  light:  '#000000',
  dark: '#343433',
  info: '#00663d',
  accent: '#faad39',
  grey: "#bebebe",
  green: "#319B31",
  pink: '#D138BF',
  blue: '#437c90',
  lightBlue: '#44CCFF',
  red: '#f15e58',
  lightGreen: '#97d1ac',
  toolbar: '#326baf'


  // tertiary: colors.pink.base,
  // anchor: colors.red.base
}
